export default __webpack_public_path__ + "static/media/PUC_TV.97eb11e0.jpg";